'use strict';

// dom
import {
	h1, a, div, header,
	section, button, span,
	ul, li, i,
	table, thead, tbody, tr, th, td
} from 'iblokz-snabbdom-helpers';

import {obj, fn, str} from 'iblokz-data';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);

import {fieldLabel} from './form/label';

const getName = field => field.name || field.title || field;

export default ({fields = [], list = [], actions = [], mods = {}, i18n = {}}) => table('.grid', [
		thead(
			tr([].concat(
				fields.map(field => {
					const name = field.name || field;
					return th(field.title || fieldLabel(i18n, name) || field);
				}),
				th(i18n?.common?.actions?.actions ?? 'Actions')
			)
		)),
		tbody(list.map(doc =>
			tr([].concat(
				fields
					.map(field => ({...field, value: doc[field.name || field] || ''}))
					.map(field => ({
						...field,
						value: field.value instanceof Array ? field.value.map(getName).join(', ') : getName(field.value)
					}))
					.map(({name, value, schema = {}}) =>
						(mods[name] && mods[name] instanceof Function)
							? td(mods[name](value))
							: obj.switch(schema.type, {
								Date: () => td([
									value && dayjs(value).isValid()
										? dayjs(value).format('ll HH:mm')
										: (value || (i18n?.common?.actions?.na ?? 'n/a'))
								]),
								Boolean: () => td({attrs: {align: 'center'}}, i('.fa', {
									class: {
										'fa-check-square-o': value,
										'fa-square-o': !value
									}
								})),
								default: () => td([value])
							})()
					),
				td('[align="center"]', actions.reduce((arr, act) => [].concat(
					arr,
					act.href
						? a(`${act.href}${act.sel || ''}`, {
							style: {}
						}, act.title || '')
						: button(`${act.sel || '.plchldr'}`, {
							style: {},
							on: {
								click: ev => act.cb({ev, doc})
							}
						}, act.title || '')
				), []))
			))
		))
	]);
